// Versions this device escaped via a revert, held for 10 minutes, so a bundle that booted but
// dies at render is not re-applied on the next launch.
const DENYLIST_KEY = 'baobab_bundle_denylist';

export const DENYLIST_WINDOW_MS = 600_000;

interface DenylistEntry {
  version: string;
  deniedAt: number;
}

const readEntries = (): DenylistEntry[] => {
  try {
    const raw = localStorage.getItem(DENYLIST_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((e): e is DenylistEntry => {
      const entry = e as Partial<DenylistEntry> | null;
      return (
        typeof entry?.version === 'string' && typeof entry?.deniedAt === 'number'
      );
    });
  } catch {
    // Corrupt or unavailable storage must never block boot.
    return [];
  }
};

const writeEntries = (entries: DenylistEntry[]): void => {
  try {
    localStorage.setItem(DENYLIST_KEY, JSON.stringify(entries));
  } catch {
    // Best-effort only.
  }
};

export const denyBundle = (version: string, now: number): void => {
  const entries = readEntries().filter(
    (e) => now - e.deniedAt <= DENYLIST_WINDOW_MS,
  );
  entries.push({ version, deniedAt: now });
  writeEntries(entries);
};

export const readDenylist = (now: number): string[] =>
  readEntries()
    .filter((e) => now - e.deniedAt <= DENYLIST_WINDOW_MS)
    .map((e) => e.version);

export const clearDenylist = (): void => {
  try {
    localStorage.removeItem(DENYLIST_KEY);
  } catch {
    // Best-effort only.
  }
};
